<script setup>
import {ref, inject, watch, onMounted} from "vue";
import ProgressTrackingReportDiagram from "./progressTrackingReportDiagram.vue";

const props = defineProps({
    channelId: {
        type: Number,
        required: true
    }
})

const statistics = ref(null)
const statscontainer = ref()

const loadProgressTrackingStatistics = async () => {
    try {
        const response = await axios.get(route('community.member.channel.progressTrackingReport', props.channelId));
        statistics.value = response.data.statistics
    } catch (error) {
        console.error("Error loading progress tracking statistics:", error);
        throw error;
    }
}

const isVisible = inject('containerTabIsVisible')

watch(isVisible, (visible) => {
    if (visible && statistics.value === null) {
        loadProgressTrackingStatistics();
    }
}, { immediate: true, deep: true });

</script>
<template>
    <div ref="statscontainer">
        <div
            v-if="statistics === null"
            class="flex justify-center"
        >
            <button-secondary
                @click="loadProgressTrackingStatistics"
                class="min-w-48 justify-center"
            >
                Load statistics
            </button-secondary>
        </div>
        <div v-if="statistics?.post_streaks" class="grid grid-cols-2 gap-4">
            <card-basic class="!mb-0" compact>
                <template v-slot:body>
                    <div class="flex items-end justify-between">
                        <div class="text-right">
                            <h1 class="text-lg">
                                {{ statistics.post_streaks.max_daily_streak }} days
                            </h1>
                        </div>
                    </div>
                    <p class="text-xs">Longest daily streak</p>
                </template>
            </card-basic>

            <card-basic class="!mb-0" compact>
                <template v-slot:body>
                    <div class="flex items-end justify-between">
                        <div class="text-right">
                            <h1 class="text-lg">
                                {{ statistics.post_streaks.current_daily_streak }} days
                            </h1>
                        </div>
                    </div>
                    <p class="text-xs">Current daily streak</p>
                </template>
            </card-basic>

            <card-basic class="!mb-0" compact>
                <template v-slot:body>
                    <div class="flex items-end justify-between">
                        <div class="text-right">
                            <h1 class="text-lg">
                                {{ statistics.post_streaks.max_reminder_days_streak }} days
                            </h1>
                        </div>
                    </div>
                    <p class="text-xs">Longest daily streak on days with reminders</p>
                </template>
            </card-basic>

            <card-basic class="!mb-0" compact>
                <template v-slot:body>
                    <div class="flex items-end justify-between">
                        <div class="text-right">
                            <h1 class="text-lg">
                                {{ statistics.post_streaks.current_reminder_days_streak }} days
                            </h1>
                        </div>
                    </div>
                    <p class="text-xs">Current daily streak on days with reminders</p>
                </template>
            </card-basic>
        </div>
        <div v-if="statistics?.question_trends" class="mt-8">
            <p class="text-center text-gray-500 text-xs">Only fields with data that can be presented as a graph are displayed; Number, Yes/No and Completion.</p>

            <ul class="space-y-4">
                <li v-for="(trend, index) in statistics.question_trends" :key="index">
                    <card-basic :compact="true">
                        <h3 class="mb-2">{{ trend.question }}</h3>
                        <ProgressTrackingReportDiagram
                            :data="trend.daily_responses"
                            :question="trend.question"
                            :question-type="trend.type"
                        />
                    </card-basic>
                </li>
            </ul>
        </div>

    </div>
</template>
